import { render, staticRenderFns } from "./AdminUtenti.vue?vue&type=template&id=136df472&"
import script from "./AdminUtenti.vue?vue&type=script&lang=js&"
export * from "./AdminUtenti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports